export default __webpack_public_path__ + "static/media/backgroundImage.117626e0.png";